import { type ReactNode } from 'react'

interface AuthContainerProps {
  children: ReactNode
}

const AuthContainer = ({ children }: AuthContainerProps) => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow-lg sm:rounded-lg sm:px-10">
          {children}
        </div>
      </div>
    </div>
  )
}

export default AuthContainer


